import React from 'react';

export default ({ hasData }: { hasData: boolean }) => {
  return (
    <div className="loading-indicator" data-has-data={hasData}>
      <div className="text">Loading...</div>
    </div>
  );
};
